import { useNavigate, useParams } from 'react-router-dom';
import { notification } from 'antd';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import './style.css';
import { getStageTasks, getWoById } from '../../../../helpers/apiCalls';
import useTemplateState from '../../../../../Template/atoms/variables';
import { useEffect } from 'react';
import useMaintenanceState from '../../../../atoms/variables';
import Input from '../../../../../Template/layoutComponents/Input';
import { parseIsoDateString } from '../../../../../helpers/misc';

import TaskReports from '../../Details/components/CommissioningTab/CriteriaTypes/TaskReports/index';
import Table from '../../../../../Template/layoutComponents/Table';
import i18n from '../../../../../_shared/translate/translate-config';
import TableTip from '../../../../../Template/layoutComponents/Table/components/tip';
import ActionCell from '../../Details/components/CommissioningTab/CriteriaTypes/TaskReports/components/ActionsCell';

const WODetails = () => {
  const { t } = useTranslation();
  const { woId } = useParams();
  const { instance } = useMsal();
  const [notificationApi, contextHolder] = notification.useNotification();

  const [tasks, setTasks] = useState(null);

  const { setPendingApiCalls } = useTemplateState();
  const { setViewDetailsItem, viewDetailsItem } = useMaintenanceState();

  useEffect(() => {
    if (!viewDetailsItem || !viewDetailsItem.token) triggerApiCalls();
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['getWoById']));

      const response = await getWoById(instance, woId);
      setViewDetailsItem(response);
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'getWoById'));
    }
  };

  const fetchTasks = async () => {
    try {
      setPendingApiCalls((current) => current.concat([`getStageTasks`]));

      const responses = await Promise.all([
        getStageTasks(instance, { token: viewDetailsItem?.token, uniqueValues: true, limit: 10 }),
      ]);

      setTasks(responses[0]);
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== `getStageTasks`));
    }
  };
  return (
    <div id='woDetails'>
      {contextHolder}
      <div className='pageContentBlock'>
        <div className='pageTitle'>{`${t('work_order')} #${viewDetailsItem?.token ?? ''}`}</div>
        <div className='blockContent'>
          <div className='detailsRow'>
            <div className='formsBody'>
              <div className='formsInputContainer'>
                <div className='formsInputLabel'>{t('contractor')}:</div>
                <div className='formsInput'>
                  <Input
                    disabled={true}
                    value={
                      viewDetailsItem?.employee?.properties?.find((prop) => prop.key === 'company')
                        ?.value
                    }
                  />
                </div>
              </div>
              <div className='formsInputContainer'>
                <div className='formsInputLabel'>{t('scheduled_date')}:</div>
                <div className='formsInput'>
                  <Input
                    disabled={true}
                    value={parseIsoDateString(viewDetailsItem?.scheduled_date ?? '')}
                  />
                </div>
              </div>
            </div>
            <div className='formsBody'>
              <div className='formsInputContainer'>
                <div className='formsInputLabel'>{t('executor')}:</div>
                <div className='formsInput'>
                  <Input
                    disabled={true}
                    value={
                      viewDetailsItem?.employee?.properties?.find((prop) => prop.key === 'name')
                        ?.value
                    }
                  />
                </div>
              </div>
              <div className='formsInputContainer'>
                <div className='formsInputLabel'>{t('status')}:</div>
                <div className='formsInput'>
                  <Input disabled={true} value={viewDetailsItem?.status} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='pageContentBlock' style={{ gap: 0 }}>
        <div key={viewDetailsItem?.token} className='pageTitle'>
          {t('tasks')}
        </div>
        {viewDetailsItem?.token && (
          <TaskReports
            showNameOnTable={true}
            customGetParams={{
              token: viewDetailsItem?.token,
            }}
            setAllTasks={() => {}}
            ignoreExternalItemsChange={true}
            externalForceReload={true}
          />
        )}
      </div>
    </div>
  );
};

export default WODetails;
